import { render, staticRenderFns } from "./ConfirmacionAuxilios.vue?vue&type=template&id=e4fff232&scoped=true&"
import script from "./ConfirmacionAuxilios.vue?vue&type=script&lang=js&"
export * from "./ConfirmacionAuxilios.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmacionAuxilios.vue?vue&type=style&index=0&id=e4fff232&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fff232",
  null
  
)

export default component.exports